export enum MomentSecondsReplacements {
  EN = 'just now',
  FI = 'juuri nyt',
  SV = 'alldeles nyss',
  DE = 'gerade',
  FR = 'à l’instant',
  NL = 'zojuist',
}

export const TimeTranslations: Record<string, [string, string][]> = {
  en: [
    [MomentSecondsReplacements.EN, '1s'],
    ['a minute', '1m'],
    [' minutes', 'm'],
    ['an hour', '1h'],
    [' hours', 'h'],
    ['a day', '1d'],
    [' days', 'd'],
    ['a month', '1mo'],
    [' months', 'mo'],
    ['a year', '1y'],
    [' years', 'y'],
  ],
  fi: [
    [MomentSecondsReplacements.FI, '1s'],
    ['minuutti', '1 min'],
    [' minuuttia', 'min'],
    ['minuutin', 'min'],
    ['tunti', '1 h'],
    [' tuntia', 'h'],
    ['tunnin', 'h'],
    ['päivä', '1 vrk'],
    [' päivää', 'vrk'],
    ['päivän', 'vrk'],
    ['kuukausi', '1 kk'],
    [' kuukautta', 'kk'],
    ['kuukauden', 'kk'],
    ['vuosi', '1 v'],
    [' vuotta', 'v'],
    ['vuoden', 'v'],
  ],
  sv: [
    [MomentSecondsReplacements.SV, '1s'],
    ['en minut', '1 min'],
    [' minuter', 'min'],
    ['en timme', '1 h'],
    [' timmar', 'h'],
    ['en dag', '1 d'],
    [' dagar', 'dgr'],
    ['en månad', '1 mån'],
    [' månader', 'mån'],
    ['ett år', '1 år'],
    [' år', 'år'],
  ],
  de: [
    [MomentSecondsReplacements.DE, '1s'],
    ['eine Minute', '1m'],
    [' Minuten', 'm'],
    ['eine Stunde', '1h'],
    [' Stunden', 'h'],
    ['ein Tag', '1T'],
    [' Tage', 'T'],
    ['ein Monat', '1M'],
    [' Monate', 'M'],
    ['ein Jahr', '1y'],
    [' Jahre', 'y'],
  ],
  fr: [
    [MomentSecondsReplacements.FR, '1s'],
    ['une minute', '1m'],
    [' minutes', 'm'],
    ['une heure', '1h'],
    [' heures', 'h'],
    ['un jour', '1j'],
    [' jours', 'j'],
    [' mois', 'M'],
    ['un mois', '1M'],
    ['un an', '1a'],
    [' ans', 'a'],
  ],
  nl: [
    [MomentSecondsReplacements.NL, '1s'],
    ['één minuut', '1m'],
    [' minuten', 'm'],
    ['één uur', '1h'],
    [' uur', 'h'],
    ['één dag', '1d'],
    [' dagen', 'd'],
    ['één maand', '1mo'],
    [' maanden', 'mo'],
    [' jaar', 'y'],
    ['één jaar', '1y'],
  ],
};
